<med-label
  [label]="label"
  [name]="name"
  [disabled]="disabled"
  [required]="required"
  [labelClass]="labelClass"
  (clickOutside)="onToggle(false)"
>
  <div [ngClass]="{ field__container: hasErrorPadding }">
    <div
      #elRef
      class="med-multi-select"
      [ngClass]="{ extend: overlayVisible }"
    >
      <div
        #buttonRef
        class="med-multi-select__box field"
        [ngClass]="classList"
        (click)="onToggle(!overlayVisible, $event)"
      >
        <div class="med-multi-select__title">
          {{ title }}
        </div>

        <div class="med-multi-select__nav">
          <div
            [ngClass]="{ hide: !hasValue || disabled }"
            class="med-multi-select__icon med-multi-select__icon--delete"
          >
            <med-icon-x
              *ngIf="!hideClearBtn"
              size="14"
              (click)="onClear($event)"
            ></med-icon-x>
          </div>

          <div
            class="med-multi-select__icon med-multi-select__icon--arrow"
            [ngClass]="{ rotate: overlayVisible }"
          >
            <med-icon-chevron-down size="16"></med-icon-chevron-down>
          </div>
        </div>
      </div>

      <ul
        #popoverRef
        role="listbox"
        class="med-multi-select__list"
      >
        <li
          *ngIf="headerTemplate"
          class="med-multi-select__header"
        >
          <ng-container *ngTemplateOutlet="headerTemplate"></ng-container>
        </li>

        <li
          *ngIf="!options.length && emptyMessage"
          class="med-multi-select__message"
        >
          <span class="med-multi-select__message-content">
            {{ emptyMessage }}
          </span>
        </li>

        <med-multiselect-item
          *ngFor="let option of options"
          [disabled]="option.disabled || disabled || false"
          [selected]="option.value | hasActive : value"
          [option]="option"
          [template]="optionTemplate"
          (onClick)="onSelect($any(option.value))"
          (onKeydown)="onOptionKeydown($event)"
        >
        </med-multiselect-item>
      </ul>
    </div>
  </div>

  <div
    *ngIf="invalid"
    class="field__error-message up"
  >
    {{ errorMessage }}
  </div>
</med-label>
